




























































































import { createCustomEvent } from '@/modules/CustomEvent'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CasesItem } from '../../modules/class/CasesInfo'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({ components: { RemoveTag } })
export default class CasesCard extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props
  @Prop({ default: '' }) private imagePath!: string
  @Prop({ default: '' }) private imageAlt!: string
  @Prop() private linkTitle!: string
  @Prop({ default: '' }) private pageTitle!: string
  @Prop() private productNames!: CasesItem[]
  @Prop() private productCategoryList!: CasesItem[]
  @Prop() private industryCategoryList!: CasesItem[]
  @Prop() private shimadzuJounal!: boolean
  @Prop() private pdfSize!: string
  @Prop() private linkUrl!: string
  @Prop({ default: true }) private dispImage!: boolean
  @Prop({ default: '' }) private tag!: string

  // ------------------------------------------------------------------------------------------------
  // data

  // ------------------------------------------------------------------------------------------------
  // hooks

  // ------------------------------------------------------------------------------------------------
  // computed

  // ------------------------------------------------------------------------------------------------
  // methods
  /**
   * リンククリック時の動作
   */
  private linkClick(url: string) {
    if (window.iwgp?.existDlEvent && this.shimadzuJounal) {
      // DLイベントが定義されている場合は、DLイベントを発生させる
      createCustomEvent('start-pdf-download', { url: url })
    } else {
      // DLイベントが定義されていない場合は、そのまま画面遷移させる
      window.location.href = url
    }
  }
}
